import React from 'react'
import styled from 'styled-components'

const ScreenReaderOnly = ({ children, id }) => {
  return <StyledSpan id={id}>{children}</StyledSpan>
}

export default ScreenReaderOnly

const StyledSpan = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`
